import { camelCase, upperFirst } from 'lodash';

import Vue from 'vue';


autoImport(require.context('ui-kit/src/components'));
autoImport(require.context('@/components'));


function autoImport(ctx) {
    for (const filename of ctx.keys()) {
        const config = ctx(filename);
        const name = upperFirst(camelCase(filename.split('/').pop().replace(/\.\w+$/, '')));

        Vue.component(name, config.default || config);
    }
}
